<div class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white border border-gray-300 rounded-lg shadow-lg p-4 w-80 z-50">
  <form (ngSubmit)="submitStream()" class="flex flex-col">
    <app-notification-alert [data]="notification"></app-notification-alert>
    <h1 class="font-medium text-center text-lg mb-4">Select Your Stream</h1>
    
    <div class="w-full p-1 mb-4">
      <select [(ngModel)]="selectedStream" name="stream" required class="w-full p-1 border border-primary rounded-md focus:outline-none">
        <option disabled value="">Select a stream</option>
        <option *ngFor="let stream of streams" [value]="stream.ID">{{ stream.Name }}</option>
      </select>
    </div>
    
    <app-button-primary [disabled]="loading" type="submit">
      Submit
    </app-button-primary>
   
  </form>
</div>
